module.exports = __webpack_public_path__ + "static/rabbit-a8d5c9ebf39c8c7c398904676179f8ef.png";